var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-form"},[_c('el-form',{ref:"form",attrs:{"model":_vm.forms,"rules":_vm.rules}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }